import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import AlertDialog from './AlertDialog';
import WarningTooltip from './WarningTooltip';
import { displayTime } from '../utils/functions';
import { Context } from '../AuthContext';

const SpinnerIcon = ({ size = 'sm' }) => <FontAwesomeIcon icon={faSpinner} spin size={size} />;

const REPLACEMENT_LIMIT_TOOLTIP =
  "You've reached your Vertical Replacement limit. Additional replacements become available after your allowance resets. Upgrade to Full Access for unlimited Vertical Replacements.";

const Task = ({ task, onDelete, index, activeTab, displayToast, deleteDisabled = false }) => {
  const navigate = useNavigate();
  const { user } = useContext(Context);
  const [downloading, setDownloading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const taskStatus = task?.status === 'Updating' ? 'Completed' : task?.status;

  const deleteHandler = async (e) => {
    setDeleting(true);
    await onDelete(e);
    setDeleting(false);
  };

  const downloadVertical = async (vertical_id) => {
    setDownloading(true);
    displayToast();
    const token = await user.getIdToken();
    const url = `${process.env.REACT_APP_FLASK_WEBSERVER}download_vertical?vertical_id=${vertical_id}`;

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `${task.query}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error('Download failed:', err);
    }
    setDownloading(false);
  };

  return (
    <tr
      onClick={() =>
        !deleting && taskStatus === 'Completed' && navigate(`/vertical/${task._id}/home`)
      }
      style={{ cursor: !deleting && taskStatus === 'Completed' ? 'pointer' : 'default' }}
    >
      <td className="result-item" style={{ paddingLeft: '10px' }}>
        {task.query}
      </td>

      <td className="result-item">{displayTime(task.created_at)}</td>

      <td className="result-item">
        {activeTab === 'Private Verticals' && (
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <p
              style={{
                margin: 0,
                color: taskStatus === 'Completed' ? '#1976d2' : '#1c1b1f',
              }}
            >
              {taskStatus}
            </p>
            {taskStatus !== 'Completed' && <SpinnerIcon size="xs" />}
          </div>
        )}
        {activeTab === 'My Verticals' && task.member_count}
      </td>

      <td className="result-item">
        <div style={{ display: 'flex', gap: '10px' }}>
          {!deleting ? (
            <>
              <WarningTooltip message={deleteDisabled ? REPLACEMENT_LIMIT_TOOLTIP : null}>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <AlertDialog
                    id={task._id}
                    action={(e) => deleteHandler(e)}
                    index={index}
                    disabled={deleteDisabled}
                    dialogTitle={`Delete ${
                      activeTab === 'Private Verticals' ? 'private vertical' : 'vertical'
                    }: ${task.query}?`}
                    dialogContentText={`This action cannot be undone. This will permanently delete the ${
                      activeTab === 'Private Verticals' ? 'private vertical' : 'vertical'
                    } and remove the data from our servers.`}
                  />
                </span>
              </WarningTooltip>

              {taskStatus === 'Completed' && (
                <>
                  {downloading ? (
                    <SpinnerIcon size="lg" />
                  ) : (
                    <DownloadOutlinedIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadVertical(task._id);
                      }}
                    />
                  )}
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/vertical/${task._id}/home`);
                    }}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <img src={`${process.env.PUBLIC_URL}/open.svg`} alt="open" />
                  </div>
                </>
              )}
            </>
          ) : (
            <SpinnerIcon />
          )}
        </div>
      </td>
    </tr>
  );
};

export default Task;
